export default __webpack_public_path__ + "static/media/Union.f6d2afe2.svg";